import { Component, EventEmitter, Output } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { filter, first, switchMap, tap } from 'rxjs/operators';

import { DscParams } from '@api/compliance-adapter/compliance-adapter.models';
import { ComplianceAdapterService } from '@api/compliance-adapter/compliance-adapter.service';
import { getCurrentLanguage, getStore } from '@core/infrastructure/state/core.selectors';
import { getPaymentDetails, getSelectedPaymentMethod } from '@shared/payment/store';
import { getUserSelector } from '@shared/user/store';

@Component({
    selector: 'distance-sale-contract',
    templateUrl: './distance-sale-contract.component.html',
})
export class DistanceSaleContractComponent {
    @Output() public readonly loaded: EventEmitter<void> = new EventEmitter();

    private readonly getDscContent$: Observable<any> = combineLatest([
        this.store.select(getStore).pipe(first()),
        this.store.select(getCurrentLanguage).pipe(first()),
        this.store.select(getUserSelector).pipe(filter((user) => !!user), first()),
        this.store.select(getSelectedPaymentMethod).pipe(first()),
        this.store.select(getPaymentDetails).pipe(first()),
    ]).pipe(
        switchMap(([store, laguague, user, selectedPaymentMethods, paymentDetails]) => {
            const body: DscParams = {
                payments: [
                    {
                        paymentMethod: selectedPaymentMethods.name,
                        panSuffix: paymentDetails.number.slice(-4),
                    },
                ],
                customerId: user.identity.userId,
                storeId: store.id.toString(),
                locale: [
                    laguague.locale,
                ],
                languageId: laguague.id,
            };

            return this.dscService.createDistanceSaleContract(body);
        })
    );

    public dscContent$: Observable<string> = this.getDscContent$.pipe(
        first(),
        tap(() => { this.loaded.emit(); })
    );

    constructor(
        private readonly dscService: ComplianceAdapterService,
        private readonly store: Store
    ) { }
}
